// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_C6D","cls2":"search_work_card_redesign-cls2_cPI search_work_card_redesign-cls1_C6D","italicized":"search_work_card_redesign-italicized_r67"};